import React from 'react';
import { SectionHeader } from './SectionHeader';
import { X, Check } from 'lucide-react';
const comparisons = [{
  bad: '3-5 hs buscando por dónde empezar',
  good: 'Plan listo en 10 minutos con el planificador'
}, {
  bad: 'Estudiar mucho y retener poco',
  good: 'Técnicas que fijan el contenido en menos tiempo'
}, {
  bad: 'Bloquearse en el examen aunque sepas el tema',
  good: 'Protocolo de desbloqueo para usar en el momento'
}, {
  bad: 'No poder dormir la noche anterior',
  good: 'Rutina de noche probada para llegar descansado'
}, {
  bad: 'Reprobar y no saber cómo levantarse',
  good: 'Plan concreto para el recuperatorio (Pack Total)'
}, {
  bad: 'Siempre el mismo ciclo de crisis',
  good: 'Sistema sostenible para toda la carrera (Pack Total)'
}, {
  bad: 'Tips sueltos de TikTok que no funcionan',
  good: 'Sistema completo aplicable desde hoy'
}, {
  bad: 'Llegar al examen en pánico',
  good: 'Checklist y protocolo mental para entrar con calma'
}];
export function Comparison() {
  return <section className="py-20 px-6 lg:px-8 bg-cream" data-id="element-33">
      <div className="max-w-[1000px] mx-auto" data-id="element-34">
        <SectionHeader data-id="element-35" />
        <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-12 uppercase" data-id="element-36">
          ¿Cuánto cuesta no tenerlo?
        </h2>

        <div className="bg-white rounded-3xl shadow-sm border border-border overflow-hidden" data-id="element-37">
          <div className="grid grid-cols-2 border-b border-border bg-gray-50" data-id="element-38">
            <div className="p-6 text-center border-r border-border" data-id="element-39">
              <h3 className="font-bold text-lg md:text-xl text-red-600 flex items-center justify-center gap-2" data-id="element-40">
                <X size={24} data-id="element-41" /> Sin el sistema
              </h3>
            </div>
            <div className="p-6 text-center bg-palegreen/20" data-id="element-42">
              <h3 className="font-bold text-lg md:text-xl text-green-700 flex items-center justify-center gap-2" data-id="element-43">
                <Check size={24} data-id="element-44" /> Con Aprobá en serio
              </h3>
            </div>
          </div>

          <div className="divide-y divide-border" data-id="element-45">
            {comparisons.map((item, idx) => <div key={idx} className="grid grid-cols-2 hover:bg-gray-50/50 transition-colors" data-id="element-46">
                <div className="p-4 md:p-6 border-r border-border flex items-center gap-3" data-id="element-47">
                  <X size={18} className="text-red-400 shrink-0 hidden md:block" data-id="element-48" />
                  <p className="text-sm md:text-base text-dark/70 font-medium" data-id="element-49">
                    {item.bad}
                  </p>
                </div>
                <div className="p-4 md:p-6 flex items-center gap-3 bg-palegreen/5" data-id="element-50">
                  <Check size={18} className="text-green-500 shrink-0 hidden md:block" data-id="element-51" />
                  <p className="text-sm md:text-base font-bold text-dark" data-id="element-52">
                    {item.good}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}